"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _logger = _interopRequireDefault(require("./logger"));
/**
 * Call the consent management platform and return
 * the US privacy string value. Return null if the
 * call to the CMP times out
 * @param {Object} options
 * @param {Number} options.timeout - time in ms to wait for
 *   the CMP to respond.
 * @return {String|null} the USP string value, or null if
 *   the CMP times out.
 */


var getUSPString =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee() {
    var _ref2,
        _ref2$timeout,
        timeout,
        _args = arguments;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$timeout = _ref2.timeout, timeout = _ref2$timeout === void 0 ? 500 : _ref2$timeout;
            return _context.abrupt("return", new Promise(function (resolve) {
              try {
                var timedOut = false;

                _logger.default.debug("Fetching USP string with timeout ".concat(timeout, "ms."));

                var timeoutInstance = setTimeout(function () {
                  _logger.default.debug("Failed to get USP data. Timed out while waiting for the CMP.");

                  timedOut = true;
                  resolve(null);
                }, timeout);

                window.__uspapi('getUSPData', 1, function (uspData, success) {
                  if (timedOut) {
                    return;
                  }

                  clearTimeout(timeoutInstance);

                  if (success) {
                    _logger.default.debug("Received USP data:", uspData);

                    resolve(uspData.uspString);
                  } else {
                    _logger.default.debug("Failed to get USP data. The CMP errored.");

                    resolve(null);
                  }
                });
              } catch (e) {
                resolve(null);

                _logger.default.error(e);
              }
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getUSPString() {
    return _ref.apply(this, arguments);
  };
}();

var _default = getUSPString;
exports.default = _default;